import { timer } from 'rxjs';
import { Subject } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ServidorSrh2 } from '../_classes/servidor-srh2';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { Util } from '../_classes/util';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { RestService } from '../_servicos/rest.service';

@Component({
  selector: 'app-pessoa-documento',
  templateUrl: './pessoa-documento.component.html',
  styleUrls: ['./pessoa-documento.component.scss'],
})
export class PessoaDocumentoComponent implements OnInit {
  private readonly recurso: string = 'pessoa-documento'; //mesmo que a rota
  carregando = false;

  //servidor$: Observable<Servidor>;
  //servidor: Servidor;

  //servidorSrh2$: Observable<ServidorSrh2>;
  //servidorSrh2: ServidorSrh2;

  erros$ = new Subject<boolean>();

  constructor(
    public servService: ServidorService,
    private alertService: ModalAlertaService,
    public env: EnvService,
    private service: RestService
  ) {
    this.carregando = true;
  }

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  ngOnInit() {
    this.atualizar();
  }

  atualizar() {
    this.carregando = true;

    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    this.carregando = false;
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
  }

  /*
  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    this.servidor =
      this.servService.getServidorAtualRedirecionando('pessoa-documento');

    if (this.servidor) {
      this.servidorSrh2$ = this.service
        .getServidorSrh2(this.servidor.nrMatricula)
        .pipe(
          tap((a) => this.executarAoCarregarDatasource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return empty();
          })
        );
    }
  }
*/
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
